import React, { useState, useEffect } from 'react';
import styles from '../styles.module.scss';

interface CreatePlaceholderModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (name: string, isRequired: boolean) => void;
  isCreating?: boolean;
}

const CreatePlaceholderModal: React.FC<CreatePlaceholderModalProps> = ({
  isOpen,
  onClose,
  onCreate,
  isCreating = false,
}) => {
  const [name, setName] = useState('');
  const [isRequired, setIsRequired] = useState(false);

  // Reset form when modal opens
  useEffect(() => {
    if (isOpen) {
      setName('');
      setIsRequired(false);
    }
  }, [isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedName = name.trim();
    if (!trimmedName) return;
    onCreate(trimmedName, isRequired);
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget && !isCreating) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.deleteModal} onClick={handleOverlayClick}>
      <div className={styles.deleteModalContent} onClick={(e) => e.stopPropagation()}>
        <h3 className={styles.deleteModalTitle}>Add New Placeholder</h3>
        <form onSubmit={handleSubmit}>
          <div className={styles.editFormField}>
            <label className={styles.fieldLabel}>Name</label>
            <input
              type="text"
              className={styles.valueInput}
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter placeholder name..."
              autoFocus
              disabled={isCreating}
            />
          </div>
          <div className={styles.editFormField}>
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={isRequired}
                onChange={(e) => setIsRequired(e.target.checked)}
                disabled={isCreating}
              />
              <span>Required field</span>
            </label>
          </div>
          <div className={styles.deleteModalActions}>
            <button
              type="button"
              className={styles.cancelButton}
              onClick={onClose}
              disabled={isCreating}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={styles.applyButton}
              disabled={!name.trim() || isCreating}
              style={{ width: 'auto', margin: 0 }}
            >
              {isCreating ? 'Creating...' : 'Create'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreatePlaceholderModal;
